const topics = [
  { tag: '夏季新番2026', hot: true },
  { tag: '异世界转生', hot: true },
  { tag: '恋爱喜剧', hot: false },
  { tag: '热血少年', hot: true },
  { tag: '治愈日常', hot: false },
  { tag: '悬疑推理番', hot: false },
  { tag: '轻改动画', hot: true },
  { tag: '原创动画', hot: false },
  { tag: '漫改新番', hot: true },
  { tag: '泡面番推荐', hot: false },
  { tag: '经典重制', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            最火热的追更动漫话题标签，看看大家都在讨论什么
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#ranking"
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200/70'
              }`}
            >
              {topic.tag}
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-pulse"></span>
              )}
            </a>
          ))}
        </div>
        <div className="mt-8 text-center">
          <p className="text-xs text-foreground-500">
            以上话题基于本周追更动漫讨论热度生成，每周更新
          </p>
        </div>
      </div>
    </section>
  );
}